import {BubblesField, Panes, prefixWithSeparator, Select, TextField} from '@management-ui/core';
import {useTheme} from '@mui/material';
import validator from 'email-validator';
import React, {useCallback, useEffect, useMemo} from 'react';
import {useFormContext} from 'react-hook-form';
import {useOptions} from '../../../../hooks';

const DEFAULT_SMS_MESSAGE = 'Hope you\'re happy with your recent purchase! If you have a moment, please share your experience and leave us a review. Thanks for your custom!';

const Fields = ({request = {}, prefix = '', children}) => {
  const theme = useTheme();

  const {/** @var {function(string): string} */watch, setValue} = useFormContext();

  const type = watch(`${prefixWithSeparator(prefix)}type`);

  const messageName = useMemo(() => `${prefixWithSeparator(prefix)}message`, [prefix]);
  const message = watch(messageName);

  const products = useOptions('reviewProducts', useCallback((list) => list.map(product => ({
    id: product.id,
    label: product.name,
    colour: theme.palette.primary.main,
  })), [theme]));

  const providers = useOptions('reviewProviders', useCallback((list) => list.map(provider => ({
    id: provider.id,
    label: provider.name,
    colour: theme.palette.secondary.main,
  })), [theme]));

  useEffect(() => {
    if (type === 'sms' && message === undefined) {
      setValue(messageName, DEFAULT_SMS_MESSAGE);
    } else if (type === 'email') {
      if (message === DEFAULT_SMS_MESSAGE) {
        setValue(messageName, '');
      } else if (message === '') {
        setValue(messageName, undefined);
      }

    }
  }, [setValue, type, messageName, message]);

  return (
    <Panes
      entity={request}
      prefix={prefix}
      panes={[
        {
          title: 'Contact Details',
          fields: [
            <Select
              name="type"
              prefix={prefix}
              options={[
                {title: 'Email', value: 'email'},
                {title: 'SMS', value: 'sms'}
              ]}
              label="Type"
            />,
            <TextField
              name="name"
              prefix={prefix}
              label="Name"
              rules={{required: 'Please enter a name'}}
            />,
            <TextField
              name="email"
              prefix={prefix}
              label="Email Address"
              rules={{
                ...(type === 'email' ? {
                  required: 'Please enter an email address'
                } : {}),
                validate: value => {
                  if (value) {
                    return validator.validate(value) ? true : 'Please enter a valid email address';
                  }
                  return true;
                }
              }}
              autoComplete="email"
            />,
            <TextField
              name="phone"
              prefix={prefix}
              label="Telephone Number"
              rules={type === 'sms' ? {
                required: 'Please enter a mobile phone number'
              } : {}}
            />,
            <TextField
              name="message"
              prefix={prefix}
              label="Message"
              fieldProps={{
                multiline: true,
                rows: 5
              }}
            />
          ]
        },
        {
          title: 'Reviews to Request',
          fields: [
            <BubblesField
              name="products"
              prefix={prefix}
              label="Products"
              bubbles={products}
              multiSelect={type === 'email'}
            />,
            <BubblesField
              name="providers"
              prefix={prefix}
              label="Providers"
              bubbles={providers}
              multiSelect={type === 'email'}
            />
          ]
        }
      ]}
      title={null}
    >{children}</Panes>
  );
};

export default Fields;
